<template>
  <v-card class="mb-1 ticket grow">
    <v-card-text :style="{ color: status }" style="border-left: 5px solid">
      <v-layout>
        <v-flex>
          <div class="font-weight-bold">{{ ticket.subject }}</div>
          <div class="caption">{{ ticket.details }}</div>
        </v-flex>
        <edit-ticket-only
          v-model="ticket"
          :livechat="true"
          @editTicket="onEditTicket"
          :loading="loading"
        ></edit-ticket-only>
      </v-layout>
      <v-layout>
        <v-flex>
          <div class="caption grey--text">
            {{ ticket.starttime | dateFormat('DD/MM/YYYY HH:mm') }}
          </div>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-chip disabled class="white--text" small :color="status">{{ ticket.status }}</v-chip>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import EditTicketOnly from '@/components/view/template/ticket/EditTicket.vue'
export default {
  props: ['value'],
  data() {
    return {
      loading: false,
      ticket: this.value,
    }
  },
  components: {
    EditTicketOnly,
  },
  computed: {
    status() {
      switch (this.ticket.status.trim().toLowerCase()) {
        case 'pending':
          return '#fb8c00'
          break
        case 'closed':
          return '#e0e0e0'
          break
        case 'cancelled':
          return '#ff5252'
          break
        case 'cancelled by customer':
          return '#fd87ee'
          break
        case 'answered':
          return '#2196f3'
          break
        case 'open':
          return '#4CAF50'
          break

        default:
          return ''
          break
      }
    },
  },
  methods: {
    async onEditTicket(ticket) {
      this.ticket = ticket
      // var response = await this.getTicketById(ticket.id)
      // var index = this.tickets.findIndex(el => {
      //   return el.id == ticket.id
      // })
      // if (index != -1 && response.data && response.data.length > 0) {
      //   this.$set(this.tickets, index, response.data[0])
      // }
    },
    getTicketById(id) {
      var data = {
        id: id,
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ticket {
  &.grow {
    z-index: 6;
    transition: all 0.2s ease-in-out;
  }
  &.grow:hover {
    transform: scale(1.02);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketItem.vue